module.exports = __webpack_public_path__ + "img/downloadBlue.77c79994.svg";